import { ChangeDetectionStrategy, Component, OnInit, inject } from '@angular/core';
import { Router } from '@angular/router';
import { routePath } from '@brightside-web/desktop/data-access/core-services';
import { TranslateModule } from '@ngx-translate/core';
import { ActionCardConfigInterface } from 'libs/brightside-ui/src/lib/action-card/action-card.component';
import { BrightsideUiModule } from 'libs/brightside-ui/src/lib/brightside-ui.module';

@Component({
    selector: 'brightside-web-external-lenders-action-card',
    imports: [BrightsideUiModule, TranslateModule],
    templateUrl: './external-lenders-action-card.component.html',
    styleUrl: './external-lenders-action-card.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class ExternalLendersActionCardComponent {
  data: { route: string | undefined };
  actionCardConfig: ActionCardConfigInterface = {
    label: 'TAKE_ACTION',
    labelBold: true,
    labelSubRemoveDash: true,
    labelIcon: 'icon-actions',
    labelIconSize: 22,      
    title: 'LENDER_ALTERNATIVES_TITLE',
    body: 'LENDER_ALTERNATIVES_DESC',
    cardStyle: 'small',
    shadow: true,
    marginBottom: 'small',
  };

  private _router = inject(Router);

  navigate(): void {
    this._router.navigate([this.data?.route || routePath('lender_alternatives')]);
  }
}
